module.exports = __webpack_public_path__ + "img/img_marketing_retail@3x.a3ce0d79.png";